import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { CollapsiblePanel } from './CollapsiblePanel';
import { TicketListingsSearch } from './TicketListingsSearch';
import { usePortalData } from '../data/usePortalData';
import { jsx as _jsx } from "react/jsx-runtime";
export function InboxNavPanel(props) {
  var _data$settings;
  const {
    data
  } = usePortalData();
  const title = (data === null || data === void 0 || (_data$settings = data.settings) === null || _data$settings === void 0 ? void 0 : _data$settings.ticketLabelOverride) || I18n.text('customer-portal-app.inboxNavPanel.title');
  const titleNode = /*#__PURE__*/_jsx(Text, {
    as: "h2",
    color: "text-core-default",
    typography: "heading-300",
    children: title
  });
  if (props.isMobile) {
    return /*#__PURE__*/_jsx(CollapsiblePanel, {
      mode: "overlay",
      isOpen: props.isInboxNavOpen,
      onClose: () => props.setIsInboxNavOpen(false),
      align: "left",
      inlineSize: "100dvw",
      ariaCloseLabel: I18n.text('customer-portal-app.inboxNavPanel.ariaClose'),
      title: titleNode,
      children: /*#__PURE__*/_jsx(TicketListingsSearch, {
        screen: "inbox-nav",
        clearable: false,
        inlineSize: "100%"
      })
    });
  }
  return /*#__PURE__*/_jsx(CollapsiblePanel, {
    mode: "sidebar",
    borderSide: "end",
    expandAriaLabel: I18n.text('customer-portal-app.panel.expandTooltip'),
    collapseAriaLabel: I18n.text('customer-portal-app.panel.collapseTooltip'),
    title: titleNode,
    children: /*#__PURE__*/_jsx(TicketListingsSearch, {
      screen: "ticket-details-inbox-nav",
      clearable: true,
      inlineSize: "100%"
    })
  });
}